import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { from, Observable } from "rxjs";

import { InitService } from "@core-services/init.service";
import { ServiceNames } from "@models/service_enums";

@Injectable({
	providedIn: "root"
})
// TODO: eslint fix
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class InitResolver {
	private first: boolean = true;

	public constructor(private initService: InitService) {}

	public resolve(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean> | Promise<boolean> | boolean {
		if (this.initService.didInit([ServiceNames.MASTER_DATA, ServiceNames.INIT_ASSETS_SERVICE])) {
			if (this.first) {
				console.info("Masterdata (and assets init) finished, checking other services");
			}
			return this.checkOtherServices();
		}
		if (this.first) {
			console.info("Masterdata (and assets init) not finished, waiting...");
		}
		return new Promise((servicesLoaded) => {
			this.initService.getInitiatedServicesAsObservable().subscribe((services) => {
				if (this.initService.didInit([ServiceNames.MASTER_DATA, ServiceNames.INIT_ASSETS_SERVICE])) {
					console.info("Masterdata (and assets init) finished loading, checking other services");
					this.checkOtherServices().subscribe(() => {
						servicesLoaded(true);
					});
				}
			});
		});
	}

	// TODO: eslint fix
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	private checkOtherServices(): Observable<any> {
		const servicesToWait: Observable<boolean>[] = [];
		const serviceNamesToWait: string[] = [];

		[
			ServiceNames.CRYPTO_WALLET,
			ServiceNames.METAL_WALLET,
			ServiceNames.PROFILE,
			ServiceNames.SAVINGS,
			ServiceNames.TRADABLE_WALLET_LIST
		].forEach((service: string) => {
			if (!this.initService.didInit([service])) {
				serviceNamesToWait.push(service);
				servicesToWait.push(this.initService.getInitObservable(service));
			}
		});

		if (servicesToWait.length !== 0) {
			console.info("Waiting for services to load:\n", serviceNamesToWait);
			return from(
				new Promise((servicesLoaded) => {
					this.initService.getInitiatedServicesAsObservable().subscribe((services) => {
						if (this.initService.didInit(serviceNamesToWait)) {
							servicesLoaded(true);
						}
					});
				})
			);
		}

		if (this.first) {
			console.info("Loaded all other services.");
			this.first = false;
		}

		return from([true]);
	}
}
